module.exports = __webpack_public_path__ + "img/blue-rectangle-table-8.ae42be3d.png";